<template>
  <div :class="`form-group ${error ? 'has-error' : ''}`">
    <label v-show="label" class="control-label">
      {{ label }}
      <span class="text-danger" v-if="requiredMark">*</span>
    </label>
    <textarea
      class="form-control"
      :value="value"
      :name="name"
      :id="id"
      :rows="rows || 4"
      v-bind="$attrs"
      @input="updateValue"
    ></textarea>
    <div v-if="showCounter" class="c-field-meta">
      <div class="c-field-meta__message">
        <small class="text-danger" v-if="error">
          {{ error }}
        </small>
        <span class="help-block" v-if="help">{{ help }}</span>
      </div>
      <small class="c-field-counter" :class="counterState && `c-field-counter--${counterState}`" aria-hidden="true">
        {{ currentLength }} / {{ maxLength }}
      </small>
      <span class="sr-only" aria-live="polite">{{ counterAnnouncement }}</span>
    </div>
    <template v-else>
      <small class="text-danger" v-if="error">
        {{ error }}
      </small>
      <span class="help-block" v-if="help">{{ help }}</span>
    </template>
  </div>
</template>

<script>
export default {
  props: [
    'value',
    'error',
    'label',
    'help',
    'id',
    'name',
    'rows',
    'requiredMark',
    // Shows "12 / 250" under the field; the limit comes from the `maxlength` attr.
    'counter'
  ],
  emits: ['update:modelValue'],
  computed: {
    maxLength() {
      return Number(this.$attrs.maxlength) || 0
    },
    showCounter() {
      return this.counter !== undefined && this.counter !== false && this.maxLength > 0
    },
    currentLength() {
      return (this.value || '').length
    },
    counterState() {
      if (this.currentLength >= this.maxLength) return 'limit'
      if (this.currentLength >= this.maxLength * 0.9) return 'near'
      return ''
    },
    // Announced only close to the limit so screen readers aren't spammed on every keystroke.
    counterAnnouncement() {
      if (this.counterState === 'limit') return 'Character limit reached'
      if (this.counterState === 'near') return `${this.maxLength - this.currentLength} characters remaining`
      return ''
    }
  },
  methods: {
    updateValue(event) {
      this.$emit('input', event.target.value)
    }
  }
}
</script>

<style scoped lang="scss">
.c-field-meta {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;

  &__message {
    min-width: 0;
  }
}

.c-field-counter {
  flex-shrink: 0;
  margin-left: auto;
  margin-top: 2px;
  font-size: 12px;
  line-height: 1.4;
  color: #8a94a0;
  // Fixed-width digits keep the counter from jittering while typing.
  font-variant-numeric: tabular-nums;
  white-space: nowrap;

  &--near {
    color: #b26a00;
  }

  &--limit {
    color: #a94442;
    font-weight: 600;
  }
}
</style>
